import { Collapse, Row, Col, Progress, Card } from 'antd';
import React, { useState } from 'react';
import { CaretRightOutlined } from '@ant-design/icons';
import Title from 'components/Title';
import { TpAuthorizationResponse } from 'services/thirdParty';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { toCurrency } from 'utils/utils';
import ParListSelect from 'components/ParListSelect';
import FormInput from 'components/FormInput';
import SaveButton from 'components/SaveButton';
import PlafondsSFS from './PlafondsSFS';
import ActivitiesSFS from './ActivitiesSFS';
import OptionsSFS from './OptionsSFS';

const { Panel } = Collapse;

export type tabPlafondsandGradingSFSProps = {
  id: number;
  tpauthlist: TpAuthorizationResponse[];
  data?: any;
};

const TabPlafondsandGradingSFS = ({
  id,
  tpauthlist,
  data,
}: tabPlafondsandGradingSFSProps) => {
  let tpAuthList = tpauthlist?.filter((tp) => tp.authstatus === 'ACTIVE');

  let tpAuthDetails = tpAuthList?.flatMap((tp) => tp.authDetail);

  const [plafond, setPlafond] = useState(false);
  const [activity, setActivity] = useState(false);
  const [option, setOption] = useState(false);


  let name = data ? data?.generalData?.tpname : '';

  return (
    <Card bordered={false} title={name}>
      {plafond ? (
        <PlafondsSFS id={id} tpauthlist={tpauthlist} />
      ) : activity ? (
        <ActivitiesSFS id={id} tpauthlist={tpauthlist} />
      ) : option ? (
        <OptionsSFS id={id} tpauthlist={tpauthlist} />
      ) : (
        <>
          <Collapse
            bordered={false}
            expandIcon={({ isActive }) => (
              <CaretRightOutlined
                style={{ fontSize: 24, float: 'left' }}
                rotate={isActive ? 90 : 0}
              />
            )}
            expandIconPosition="start"
            defaultActiveKey={['0']}
          >
            {tpAuthDetails?.map((auth, index) => {
              let availableamount = (
                (1 - auth.authdetailavailableamount / auth.authdetailamount) *
                100
              ).toFixed(2);

              let totalconsomme = toCurrency(
                auth.authdetailusedamount + auth.authdetailbookedamount,
                auth.currcode ?? localStorage.getItem('currcode')
              );
              return (
                <Panel
                  header={<Title level={5} comcode={auth.offerlabel}></Title>}
                  key={index}
                  style={{
                    marginBottom: 24,
                    overflow: 'hidden',
                    background: '#f7f7f7',
                    border: 10,
                    borderRadius: 2,
                    boxShadow:
                      'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
                  }}
                >
                  <Row gutter={16}>
                    <Col span={4}>
                      <Row>
                        <Col xs={24}>
                          <FormInput
                            name="Activite autorisée"
                            initialValue="OUI"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={24}>
                          <FormInput
                            name="Perméabilite autorisée"
                            initialValue="NON"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={24}>
                          <FormInput
                            name="Saisonalite Active"
                            initialValue="NON"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={24}>
                          <FormInput
                            name="Suractivite Active"
                            initialValue="NON"
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col span={12}>
                      <Row gutter={80} style={{ marginLeft: '5%' }}>
                        <Col xs={12}>
                          <FormInput
                            name={'authdetailamount' + index}
                            comcode="authdetailamount"
                            initialValue={toCurrency(
                              auth.authdetailamount,
                              auth.currcode ?? localStorage.getItem('currcode')
                            )}
                          />
                          <Progress
                            percent={parseFloat(availableamount)}
                            strokeWidth={20}
                            strokeLinecap="square"
                            strokeColor={
                              parseFloat(availableamount) <= 50
                                ? 'green'
                                : parseFloat(availableamount) <= 80
                                ? 'yellow'
                                : 'red'
                            }
                          />
                        </Col>
                        <Col xs={12}></Col>
                      </Row>
                      <Row
                        justify="center"
                        style={{
                          color: '#243882',
                          fontWeight: 'bold',
                          marginBottom: '5%',
                        }}
                      >
                        <GetLabel label="CONSOMMATIONS" />
                      </Row>
                      <Row gutter={80}>
                        <Col span={8} xs={12}>
                          <FormInput
                            name={'authdetailbookedamount' + index}
                            comcode="authdetailbookedamount"
                            initialValue={toCurrency(
                              auth.authdetailbookedamount,
                              auth.currcode ?? localStorage.getItem('currcode')
                            )}
                          />

                          <FormInput
                            name={'authdetailusedamount' + index}
                            comcode="authdetailusedamount"
                            initialValue={toCurrency(
                              auth.authdetailusedamount,
                              auth.currcode ?? localStorage.getItem('currcode')
                            )}
                          />
                        </Col>
                        <Col span={12}>
                          <FormInput
                            name={'totalconsomme' + index}
                            initialValue={totalconsomme}
                          />
                          <FormInput
                            name={'authdetailavailableamount' + index}
                            comcode="authdetailavailableamount"
                            initialValue={toCurrency(
                              auth.authdetailavailableamount,
                              auth.currcode ?? localStorage.getItem('currcode')
                            )}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <FormInput name="limitcontrol">
                        <ParListSelect parcode="LIMITCTRL" />
                      </FormInput>
                    </Col>
                  </Row>
                </Panel>
              );
            })}
          </Collapse>
          <Row gutter={12} justify="center">
            <Col span={!Number(id) ? 5 : 4}>
              <SaveButton
                comcode="Modifications des activites"
                custom={{ height: 50 }}
                onClick={() => {
                  setActivity(true);
                }}
                disabled
              />
            </Col>
            <Col span={!Number(id) ? 5 : 4}>
              <SaveButton
                comcode="Modifications des plafonds"
                custom={{ height: 50 }}
                onClick={() => {
                  setPlafond(true);
                }}
                disabled
              />
            </Col>
            <Col span={!Number(id) ? 5 : 4}>
              <SaveButton
                comcode="Modifications des options"
                custom={{ height: 50 }}
                onClick={() => {
                  setOption(true);
                }}
                disabled
              />
            </Col>
          </Row>
        </>
      )}
    </Card>
  );
};

export default TabPlafondsandGradingSFS;
